export default __webpack_public_path__ + "media/create-game.220f4595.png";